import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import Layout from '../components/layout/Layout';

import Seo from '../components/seo/Seo';

import MarketingHome from '../components/home/MarketingHome';

import { scrollToWebsiteSection } from '../components/common/ScrollLink';
import { buildAbsoluteUrl, getSiteOrigin } from '../config/seo';



const HomePage = () => {

  const location = useLocation();



  useEffect(() => {

    const hash = location.hash;

    const stateId = location.state?.scrollToId;

    if (!hash && !stateId) return;

    const id = (hash ? hash.replace('#', '') : stateId);



    const scrollToId = () => scrollToWebsiteSection(id);



    requestAnimationFrame(() => scrollToId());



    let attempts = 0;

    const maxAttempts = 20;

    const interval = setInterval(() => {

      attempts += 1;

      if (scrollToId() || attempts >= maxAttempts) {

        clearInterval(interval);

      }

    }, 50);



    requestAnimationFrame(() => scrollToId());



    return () => clearInterval(interval);

  }, [location.pathname, location.hash, location.state]);



  return (

    <Layout>

      <Seo

        title="Smart Scheduling Software"

        description="Manage appointments, staff, and customer relationships in one place. Improve efficiency and grow faster with Neat Schedule."

        image="/images/preview.png"

        canonicalPath="/"

        keywords={[

          'appointment scheduling software',

          'online booking system',

          'staff scheduling',

          'client management',

          'appointment reminders',

          'small business scheduling',

        ]}

        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Neat Schedule',
            url: getSiteOrigin(),
            logo: buildAbsoluteUrl('/neatschedule.png'),
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Neat Schedule',
            url: getSiteOrigin(),
            potentialAction: {
              '@type': 'SearchAction',
              target: `${getSiteOrigin()}/?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          },
        ]}

      />

      <MarketingHome />

    </Layout>

  );

};



export default HomePage;

